import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox } from 'components/basic'
import { UserEditor } from 'projects/flow-gui-access/components/2.4'
import { notify } from 'helpers'
import http from 'API/http'
import Unauthorized from 'projects/flow-gui-access/views/core/unauthorized.js'

class User extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: null
    }
  }

  componentDidMount () {
    console.log(this.props);
    this.getUser(this.props.match.params.userid)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.match.params.userid === nextProps.match.params.userid) return
    this.getUser(nextProps.match.params.userid)
  }

  async getUser (userid) {
    var [err, res] = await http.get('2.4/users/' + userid)
    if (err) return notify.alert('', res.message, 'error')
    this.setState({user: res.data, updated: Date.now()})
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: `${res.data.name}`
    })
  }
  async deleteUser () {
    notify.deleteConfirm('This will delete this user', async confirmed => {
      if (!confirmed) return
      var [err, res] = await http.delete('2.4/users/' + this.state.user.userId)
      if (err) return notify.alert('', res.cause, 'error')
      notify.success('User deleted')
      window.location.hash = '/users/'
    })
  }
  render () {
    if (!this.state.user) return null
    if (!this.state.user.admin && this.state.user.userId !== this.props.match.params.userid) return <Unauthorized />
    return (
      <div className='content-wrapper'>
        <ContentHeader title='User' icon='fa-user' subtitle={`${this.state.user.name}`} buttons={[
          { hidden: !this.props.user.admin, icon: 'fa-arrow-left', event: () => (window.location.hash = '/users') },
          { hidden: !this.props.user.admin, icon: 'fa-trash', event: e => this.deleteUser() }
        ]} />
        <hr />
        <div className='row'>
          <UserEditor user={this.state.user} />
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
User = connect(state => state.siteReducer)(User)
export default User



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/users/user.js